/* global appData */

import { mapState } from 'vuex';

//import { SpringSpinner } from 'epic-spinners';

// Template and media files
import template from './loading-screen.vhtml';
import logo from '../../../_img/logo-esbjerghavn.svg';

import './loading-screen.scss';

export default {
	template: template,
	components: {
		logo,
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/loading-screen/loading-screen.js